import {
  getGridNumericOperators,
  getGridStringOperators,
  getGridDateOperators,
  getGridBooleanOperators,
  getGridSingleSelectOperators,
  GridFilterInputValue,
} from "@mui/x-data-grid-pro";

import { _helper } from "../../GlobalFunction/dateHelper";
function findFieldName(reportCode, fieldName) {
  if (reportCode === "EquipList") {
    return fieldName === "AnlageStatus";
  } else {
    return fieldName === "LastCheckDate";
  }
}
export function dropDownFilter(key, state) {
  if (key === "AnlageStatus") {
    return {
      Name: "AnlageStatus",
      Value: state === "Active" ? "INBE" : "AUSSER BETRIEB",
      Operator: "=",
      mapping: "is",
    };
  } else {
    return {
      Name: "LastCheckDate",
      Value: _helper.lastCheckDateFromCurrent(
        state === "Last 30 days" ? 30 : state === "Last 2 month" ? 60 : 90,
      ),
      Operator: ">",
      mapping: "before",
    };
  }
}
export function changeoPerator2Mui(operator, _type, name) {
  if (["int", "float", "number"].includes(_type.toLowerCase())) {
    if (["=", "!=", ">", "<", ">=", "<="].includes(operator)) {
      return operator;
    }
  }
  if (_type === "datetime" && operator === "=") {
    return "is";
  }
  if (
    ["nio", "anlagestatus", "inspectionresult"].includes(name.toLowerCase())
  ) {
    return "is";
  }
  switch (operator) {
    // String comparison operators
    case "*":
      return "startsWith";
    case "=":
      return "equals";
    case "%":
      return "contains";
    case "$":
      return "endsWith";
    case "#":
      return "isEmpty";

    // Date comparison operators
    case ">":
      return "after";
    case ">=":
      return "onOrAfter";
    case "<":
      return "before";
    case "<=":
      return "onOrBefore";

    // Logical operators
    case "!=":
      return "!";
    case "!=":
      return "not";

    // Default case
    default:
      return null; // Handle case where no match is found
  }
}
export function getoPerator(operator) {
  if (["=", "!=", ">", "<", ">=", "<="].includes(operator)) {
    return operator;
  }
  switch (operator) {
    case "startsWith":
      return "*";
    case "equals":
      return "=";
    case "contains":
      return "%";
    case "endsWith":
      return "$";
    case "isEmpty":
      return "#";
    case "is":
      return "=";
    case "after":
      return ">";
    case "onOrAfter":
      return ">=";
    case "before":
      return "<";
    case "onOrBefore":
      return "<=";
    case "not":
      return "!=";
    case "!":
      return "!=";
    default:
      return null; // Handle case where no match is found
  }
}

export function DropDownChange(stateValue, filterModel, reportCode) {
  const isEquipListReport = reportCode === "EquipList";
  const isAllState = stateValue === "All";
  let filtertemp = [];

  const filteredConditions = filterModel.filter(
    (item) => !findFieldName(reportCode, item.Name),
  );

  if (!isAllState) {
    filtertemp.push(
      dropDownFilter(
        isEquipListReport ? "AnlageStatus" : "LastCheckDate",
        stateValue,
      ),
    );
  }

  filterModel.length = 0;
  filterModel.push(...filteredConditions);

  return {
    updatedConditions: filterModel,
    dropDownCondition: filtertemp,
  };
}

function handleDate(dateValue) {
  const dateFormat = sessionStorage.getItem("df");
  const _tempDate = dateValue.split("-");
  const day = _tempDate[2];
  const month = _tempDate[1];
  const year = _tempDate[0];
  switch (dateFormat) {
    case "dd.MM.yyyy":
      return day + "." + month + "." + year;
    case "MM.dd.yyyy":
      return month + "." + day + "." + year;
    case "yyyy.MM.dd":
      return year + "." + month + "." + day;
    case "dd/MM/yyyy":
      return day + "/" + month + "/" + year;
    case "MM/dd/yyyy":
      return month + "/" + day + "/" + year;
  }
}

// Function to extract the filtered operators for a specific type
export function extractFilterOperator(_type, fieldName, localization) {
  const extractOperator = ["isnotempty", "isanyof", "not"];
  const notEqualOperator = {
    label: localization.notEqual,
    value: "!",
    InputComponent: GridFilterInputValue,
    InputComponentProps: {
      type:
        _type === "string" ? "text" : _type === "datetime" ? "date" : "number",
    },
  };
  switch (_type.toLowerCase()) {
    case "int":
    case "float":
      return getGridNumericOperators().filter(
        (operator) => !extractOperator.includes(operator.value.toLowerCase()),
      );

    case "string":
      if (fieldName.toLowerCase() === "anlagestatus") {
        return getGridSingleSelectOperators().filter(
          (operator) => !extractOperator.includes(operator.value.toLowerCase()),
        );
      } else {
        return getGridStringOperators()
          .filter(
            (operator) =>
              !extractOperator.includes(operator.value.toLowerCase()),
          )
          .concat(notEqualOperator);
      }

      break;
    case "datetime":
      return getGridDateOperators()
        .filter(
          (operator) => !extractOperator.includes(operator.value.toLowerCase()),
        )
        .concat(notEqualOperator);
    case "bool":
      if (["nio", "inspectionresult"].includes(fieldName.toLowerCase())) {
        return getGridSingleSelectOperators().filter(
          (operator) => !extractOperator.includes(operator.value.toLowerCase()),
        );
      } else {
        return getGridBooleanOperators().filter(
          (operator) => !extractOperator.includes(operator.value.toLowerCase()),
        );
      }
    default:
      return [];
  }
}

export function attachFilter(_filterListtemp, reportCode) {
  const _filterlist = _filterListtemp.map((item) => {
    if (
      reportCode === "EquipList"
        ? item.Name === "AnlageStatus"
        : item.Name === "LastCheckDate"
    ) {
    }
    let _value = item.Operator === "#" ? undefined : item.Value;
    if (["LastCheckDate", "NextCheckDate"].includes(item.Name)) {
      if (_value) {
        const { day, month, year } = _helper.extractYearMonthDay(_value);
        _value = year + "-" + month + "-" + day;
      }
    }
    return {
      field: item.Name,
      operator: item.mapping,
      value: _value,
    };
  });

  return { items: _filterlist };
}

export function FilterApplyHandle(
  _filterList,
  state,
  reportCode,
  headerName,
  headerType,
) {
  const { items } = {
    ..._filterList,
  };
  const filterList = [];
  let IsAnlageLastCheckValue = null;
  let fieldFound = false;
  const filterField =
    reportCode === "EquipList" ? "AnlageStatus" : "LastCheckDate";
  const includeItem = headerName.includes(filterField);
  items.forEach((element) => {
    const _operator = getoPerator(element.operator);
    if (_operator !== "#" && !element.value) {
      return;
    }
    if (includeItem && findFieldName(reportCode, element.field)) {
      fieldFound = true;
      if (reportCode === "EquipList") {
        IsAnlageLastCheckValue =
          element.value === (state === "Active" ? "INBE" : "AUSSER BETRIEB")
            ? null
            : element.value === "INBE"
              ? "Active"
              : "Inactive";
      } else {
        if (_operator === "#") {
          fieldFound = false;
        }
        IsAnlageLastCheckValue =
          _operator === "#"
            ? null
            : handleDate(element.value).trim() ===
                _helper
                  .lastCheckDateFromCurrent(state === "Last 30 days" ? 30 : 60)
                  .trim()
              ? null
              : "All";
      }
    }
    const _value =
      _operator === "#"
        ? "empty"
        : headerType[element.field].toLowerCase() === "datetime"
          ? handleDate(element.value)
          : element.value;
    filterList.push({
      Name: element.field,
      Operator: _operator,
      Value: _value,
      mapping: element.operator,
    });
  });
  return {
    filterList: filterList,
    IsAnlageLastCheckValue: IsAnlageLastCheckValue,
    fieldFound: fieldFound,
  };
}

export function attachingDropDown(_filterList = [], state, reportCode) {
  const key = reportCode === "EquipList" ? "AnlageStatus" : "LastCheckDate";

  const hasField = _filterList.some((item) => item.Name === key);

  // If the field does not exist and state is not empty, add the dropdown filter
  if (!hasField && state !== "All") {
    _filterList.push(dropDownFilter(key, state));
  }

  return _filterList;
}

export function filterlistProcessRequest(_fiteList, state, reportCode) {
  const key = reportCode === "EquipList" ? "AnlageStatus" : "LastCheckDate";
  const _tempFilter = [..._fiteList];
  let FilterList = [];
  let isInclude = false;
  if (_tempFilter.length > 0) {
    isInclude = _tempFilter.some(
      (item) => item.Name.toLowerCase() === key.toLowerCase(),
    );
  }
  if (!isInclude) {
    _tempFilter.push(dropDownFilter(key, state));
  }
  return _tempFilter;
}

export function filterModel(itemSelectedFilter, reportCode, hearderType) {
  if (itemSelectedFilter.length > 0) {
    const _filterlist = itemSelectedFilter.map((item) => {
      if (
        reportCode === "EquipList"
          ? item.Name === "AnlageStatus"
          : item.Name === "LastCheckDate"
      ) {
        // filterNameValue = { value: item.value, name: item.name };
      }
      let _value = item.Operator === "#" ? undefined : item.Value;
      if (hearderType[item.Name] === "datetime") {
        if (_value) {
          const { day, month, year } = _helper.extractYearMonthDay(_value);
          _value = year + "-" + month + "-" + day;
        }
      }
      return {
        field: item.Name,
        operator: item.mapping,
        value: _value,
      };
    });

    return { items: _filterlist };
  }
}
function areObjectsEqual(obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if both objects have the same number of keys
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Compare each key and value
  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
}
export function CompareFilter(selIdFilter, applyFilter) {
  if (selIdFilter.length !== applyFilter.length) {
    return false;
  }
  // Compare each element in the arrays
  for (let i = 0; i < selIdFilter.length; i++) {
    const obj1 = selIdFilter[i];
    const obj2 = applyFilter[i];

    // Check if both are objects and perform a deep comparison
    if (typeof obj1 === "object" && typeof obj2 === "object") {
      if (!areObjectsEqual(obj1, obj2)) {
        return false;
      }
    } else if (obj1 !== obj2) {
      return false;
    }
  }

  return true;
}
